// extracted by mini-css-extract-plugin
export var highlightFade = "_2m-4";
export var highlighted = "_2m-3";
export var table = "_2m-1";
export var tableContainer = "_2m-0";
export var totalsRow = "_2m-2";